export default "__VITE_ASSET__CkP_a2Jg__"